import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

const CTASection: React.FC = () => {
  const navigate = useNavigate();
  
  const benefits = [
    "Parents handle their own billing questions 24/7",
    "Reduce your admin time by 70% with self-service",
    "Give families the modern experience they expect",
    "14-day free trial with no credit card required"
  ];
  
  return (
    <section className="py-20 relative overflow-hidden bg-gradient-to-br from-[#FA8C00]/5 to-[#4ba3c7]/5">
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-full h-64 bg-[#FA8C00]/5 transform -skew-y-6"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all duration-500 hover:shadow-2xl hover:scale-[1.02]">
          <div className="grid md:grid-cols-2">
            {/* Left column - Image */}
            <div className="hidden md:block bg-[url('https://media.hivetivity.com/airfocus-wrdvOKfgzRo-unsplash.jpg')] bg-cover bg-center">
              <div className="h-full w-full bg-[#FA8C00]/30 backdrop-blur-sm flex items-center justify-center p-8">
                <div className="bg-white/90 p-6 rounded-lg shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl">
                  <h3 className="text-2xl font-bold text-[#FA8C00] transition-colors duration-300">15+</h3>
                  <p className="text-gray-700">hours saved weekly on parent questions</p>
                </div>
              </div>
            </div>
            
            {/* Right column - Content */}
            <div className="p-8 md:p-12">
              <h2 className="text-3xl font-bold text-gray-800 mb-6 text-left">
                Ready to stop answering the same questions over and over?
              </h2>
              
              <div className="space-y-3 mb-8 flex flex-col items-start">
                {benefits.map((benefit, index) => (
                  <div 
                    key={index} 
                    className="flex items-start group transition-all duration-300 hover:bg-gray-50 hover:scale-[1.02] p-2 rounded-lg"
                    style={{ animationDelay: `${index * 100}ms` }}
                  >
                    <CheckCircle className="h-5 w-5 text-[#7ad4a0] mr-2 flex-shrink-0 mt-0.5 transition-all duration-300 group-hover:scale-110 group-hover:text-[#5BC17F]" />
                    <p className="text-gray-700 transition-colors duration-300 group-hover:text-gray-800 text-left">{benefit}</p>
                  </div>
                ))}
              </div>
              
              <Button
                size="lg"
                className="w-full text-base py-6 bg-[#FA8C00] hover:bg-[#FA8C00]/90 transform transition-all duration-300 hover:scale-105 hover:shadow-lg active:scale-95 group"
                onClick={() => navigate("/business-trial")}
              >
                <span className="transition-transform duration-300 group-hover:scale-110">
                  Start Your Free Trial
                </span>
              </Button>
              
              <p className="text-sm text-gray-500 text-center mt-4">
                14-day trial. No credit card required
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
